import { StyleSheet } from 'react-native';

export const textLatoStyleDS = StyleSheet.create({
  TitleBold3xl: {
    fontWeight: 700,
    fontSize: 32,
    lineHeight: 40,
  },
  TitleBold2xl: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 28,
  },
  TitleBoldXl: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 24,
  },
  TitleBoldLg: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 22,
  },
  BodyBoldMd: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 20,
  },
  BodyBoldSm: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
  },
  BodyBoldXs: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 14,
  },
  BodyRegular2xl: {
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 28,
  },
  BodyRegularXl: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: 24,
  },
  BodyRegularLg: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 22,
  },
  BodyRegularMd: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 20,
  },
  BodyRegularSm: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 18,
  },
  BodyRegularXs: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 14,
  },
});

export const textWorkSansStyleDS = StyleSheet.create({
  SpTitleBoldXl: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 24,
  },
  SpTitleBoldLg: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 22,
  },
  SpTitleBoldMd: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 20,
  },
  SpTitleMediumMd: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: 20,
  },
});
